import React, { useEffect, useState } from 'react';
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import { getParameterByName } from '@shared/utils/UrlUtils';
import { Auth } from '@shared/services/Auth';
import { Redirect } from 'react-router';
import AuthWrapper from "./components/AuthWrapper";
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { useTranslation } from "react-i18next";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';


export default function CompleteRegistration() {
  const id = getParameterByName('reg', window.location.href) || '';
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    document.body.style.backgroundColor = '#FAFAFA';
    if (id) {
      Auth.validateEmail(id)
        .then(() => setIsSuccessful(true))
        .catch(() => setError('Failed'))
    }
  }, [id]);

  if (!id) {
    return <Redirect to="/"/>
  }

  if (isSuccessful) {
    return <Success/>
  }

  if (!isSuccessful && !!error) {
    return <Error/>
  }

  return <Processing/>
}

function Processing() {
  return (
    <AuthWrapper dataTest="completeReg-processing" title="Validating email" hideLoginLink={true} spinner={true}>
    </AuthWrapper>
  )
}

function Success() {
  const {t} = useTranslation();
  return (
    <AuthWrapper dataTest="completeReg-success" title="Success" hideLoginLink={true} icon={IconTypes.Tick}>
      <BodySmall className="login__title" style={{marginBottom: 16}}>{t('login.email-validated')}</BodySmall>
      <PrimaryButton dataTest="completeReg-login-button"
                     link="/login"
                     text="Log in"
                     fullWidth={true}
                     size={ButtonSize.Large}/>
    </AuthWrapper>
  )
}

function Error() {
  const {t} = useTranslation();
  return (
    <AuthWrapper dataTest="completeReg-error" title="Error">
      <BodySmall className="login__title">{t('login.email-validation-failed')}</BodySmall>
    </AuthWrapper>
  )
}
